import { render, staticRenderFns } from "./premises.vue?vue&type=template&id=0c604d25&"
import script from "./premises.vue?vue&type=script&lang=js&"
export * from "./premises.vue?vue&type=script&lang=js&"
import style0 from "./premises.vue?vue&type=style&index=0&id=0c604d25&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c604d25')) {
      api.createRecord('0c604d25', component.options)
    } else {
      api.reload('0c604d25', component.options)
    }
    module.hot.accept("./premises.vue?vue&type=template&id=0c604d25&", function () {
      api.rerender('0c604d25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Premises/premises.vue"
export default component.exports